/** 일본 都道府県 (code: ISO 3166-2, 순서 = JIS 코드 순) */
export const JP_PREFECTURES = [
  { code: "JP-01", name: "北海道" },
  { code: "JP-02", name: "青森県" },
  { code: "JP-03", name: "岩手県" },
  { code: "JP-04", name: "宮城県" },
  { code: "JP-05", name: "秋田県" },
  { code: "JP-06", name: "山形県" },
  { code: "JP-07", name: "福島県" },
  { code: "JP-08", name: "茨城県" },
  { code: "JP-09", name: "栃木県" },
  { code: "JP-10", name: "群馬県" },
  { code: "JP-11", name: "埼玉県" },
  { code: "JP-12", name: "千葉県" },
  { code: "JP-13", name: "東京都" },
  { code: "JP-14", name: "神奈川県" },
  { code: "JP-15", name: "新潟県" },
  { code: "JP-16", name: "富山県" },
  { code: "JP-17", name: "石川県" },
  { code: "JP-18", name: "福井県" },
  { code: "JP-19", name: "山梨県" },
  { code: "JP-20", name: "長野県" },
  { code: "JP-21", name: "岐阜県" },
  { code: "JP-22", name: "静岡県" },
  { code: "JP-23", name: "愛知県" },
  { code: "JP-24", name: "三重県" },
  { code: "JP-25", name: "滋賀県" },
  { code: "JP-26", name: "京都府" },
  { code: "JP-27", name: "大阪府" },
  { code: "JP-28", name: "兵庫県" },
  { code: "JP-29", name: "奈良県" },
  { code: "JP-30", name: "和歌山県" },
  { code: "JP-31", name: "鳥取県" },
  { code: "JP-32", name: "島根県" },
  { code: "JP-33", name: "岡山県" },
  { code: "JP-34", name: "広島県" },
  { code: "JP-35", name: "山口県" },
  { code: "JP-36", name: "徳島県" },
  { code: "JP-37", name: "香川県" },
  { code: "JP-38", name: "愛媛県" },
  { code: "JP-39", name: "高知県" },
  { code: "JP-40", name: "福岡県" },
  { code: "JP-41", name: "佐賀県" },
  { code: "JP-42", name: "長崎県" },
  { code: "JP-43", name: "熊本県" },
  { code: "JP-44", name: "大分県" },
  { code: "JP-45", name: "宮崎県" },
  { code: "JP-46", name: "鹿児島県" },
  { code: "JP-47", name: "沖縄県" },
] as const;
